import { useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { CardWrapper, CardHeader, CardSection } from 'foundations-components/transitional/components/Card';
import { EVENTS } from 'reporting-ui-components/lib/events';
import useCloneTracker from 'reporting-ui-components/lib/useCloneTracker';
import SRVDatawellInsightReportActions from './SRVDatawellInsightReportActions';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SRVDatawellInsightContainer = ({
  appUsageTracker,
  trackingAssetType,
  trackingApplicationName,
  trackingScreenName,
  children,
  insightReport,
  showAIBuilder = false
}) => {
  const [isDatawellShown, setIsDataWellShown] = useState(!showAIBuilder);
  const usageTracker = useCloneTracker(appUsageTracker);
  return /*#__PURE__*/_jsxs(CardWrapper, {
    onExpandedChange: ({
      target: value
    }) => {
      setIsDataWellShown(prevResult => !prevResult);
      usageTracker.track(EVENTS.toggleSummaryInsight, {
        action: value ? 'hide-summary' : 'show-summary',
        applicationName: trackingApplicationName,
        assetType: trackingAssetType,
        whereScreen: trackingScreenName
      });
    },
    compact: true,
    expandable: true,
    expanded: isDatawellShown,
    defaultExpanded: true,
    "data-test-id": "srv-datawell",
    padding: "100",
    children: [/*#__PURE__*/_jsx(CardHeader, {
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "reporting-ui-components.singleReportViewer.summaryDatawellInsight.title"
      }),
      titleSize: "medium",
      toolbar: insightReport && /*#__PURE__*/_jsx(SRVDatawellInsightReportActions, {
        appUsageTracker: appUsageTracker,
        report: insightReport
      })
    }), /*#__PURE__*/_jsx(CardSection, {
      children: children
    })]
  });
};
export default SRVDatawellInsightContainer;